import {useCallback, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectEnvelopes} from '~/common/FabricInvitation/reducers/fabricTemplate/selectors';
import {
  RESET_DESIGN_OPTIONS,
  UPDATE_DESIGN_OPTIONS,
} from '~/common/fabric/reducers/fabricDesign/constants';
import {
  selectEnvelopeId,
  selectHasEnvelopeChanged,
} from '~/common/fabric/reducers/fabricDesign/selectors';

export const useEnvelope = () => {
  const dispatch = useDispatch();
  const envelopes = useSelector(selectEnvelopes);
  const envelopeId = useSelector(selectEnvelopeId);
  const hasEnvelopeChanged = useSelector(selectHasEnvelopeChanged);

  const onEnvelopeReset = useCallback(() => {
    dispatch({
      type: RESET_DESIGN_OPTIONS,
      payload: ['envelopeId'],
    });
  }, [dispatch]);

  const onEnvelopeChange = useCallback(
    (icon) => {
      const selected = envelopes?.find((envelope) => envelope.icon === icon);
      dispatch({
        type: UPDATE_DESIGN_OPTIONS,
        payload: {envelopeId: selected.id, premiumFeaturesPristine: false},
      });
    },
    [dispatch, envelopes]
  );

  const envelopeIcons = useMemo(() => envelopes?.map(({icon}) => icon), [envelopes]);

  const selectedEnvelope = useMemo(
    () => envelopes?.find(({id}) => id === envelopeId),
    [envelopes, envelopeId]
  );

  return {onEnvelopeChange, onEnvelopeReset, envelopeIcons, selectedEnvelope, hasEnvelopeChanged};
};
